import api from "../../config/client.axios.api";
import { TAddAccountForStore } from "../../types";

export const addAccountForStoreApiRequest = async (
  infoAdd: TAddAccountForStore
) => {
  const response = await api.post(`/store/add-account`, infoAdd);
  return response.data;
};
